<script>
import FilterMenu from '../../components/filterMenu.vue';
import FilterTags from '../../components/filterTags.vue';
import Loading from '../../components/loading.vue';
import Picker from '../../components/picker.vue';

export default {
    name: "shopFilter",
    data() {
        return {
            detail: {
                children: [],
            },
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
            sort: [
                { value: 1, name: this.$t('sort[0]') },
                { value: 2, name: this.$t('sort[1]') },
                { value: 3, name: this.$t('sort[2]') },
            ],
            sortValue: 0,
            checkedActiveIndex: [],
            isShowFilter: false,
            isShowSort: false,
        };
    },
    computed: {},
    components: {
        Picker,
        FilterMenu,
        FilterTags,
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {
        sortValue(value) { 
            this.list = [];
            this.page = 1;
            this.allPage = 1;
            this.getData();
            this.isShowFilter = false;
            this.isShowSort = false;
        },
        '$route': {
            handler: function () { 
                this.list = [];
                this.page = 1;
                this.allPage = 1;
                this.getData();
                this.isShowFilter = false;
                this.isShowSort = false;
            }
        },
    },
    methods: {
        getData() { 
            if (this.isLoading) { 
                return;
            }
            this.isLoading = true;
            this.$store.dispatch('getShopFilter', {
                category_id: this.$route.params.id,
                ids: this.$route.query.id ? this.$route.query.id : '',
                page: this.page,
                limit: 12,
                keyword: '',
                sort: this.sort[this.sortValue].value,
            }).then((result) => {
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.goods.list);
                    this.allPage = result.data.goods.last_page;
                    this.detail = result.data.category;
                    // 设置默认选中
                    if (this.$route.query.id) { 
                        const ids = this.$route.query.id.split(',');
                        this.checkedActiveIndex = this.detail.children.map((v, i) => {
                            const checked = v.children.findIndex(item => {
                                return ids.findIndex(v => v == item.id) != -1
                            })
                            return checked != -1 ? checked : null;
                        });
                    } else {
                        this.checkedActiveIndex = this.detail.children.map(() => null);
                    }
                }
                this.isLoading = false;
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getData();
        },
        changeChecked(value) { 
            let query = {};
            let arr = [];
            // 根据索引获取id数组
            value.forEach((v, i) => {
                if (v != null) { 
                    arr.push(this.detail.children[i].children[v].id);
                }
            })
            // 转字符串
            const ids = arr.join(',');
            if (ids != '') {
                query.id = ids;
            }
            this.$router.push({
                path: this.$route.path,
                query
            })
        },
        selectChange(e){ 
            console.log(e.target.value)
        }
    },
};
</script>

<template>
    <div class="filter layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url(${ detail.image });`"></div>
        </div>
        <div class="only_mobile">
            <div class="filter_tabs flex">
                <div class="item" :class="{active: isShowFilter}" @click="isShowFilter = !isShowFilter">
                    <div class="name">筛选</div>
                </div>
                <div class="item" :class="{active: isShowSort}" @click="isShowSort = !isShowSort">
                    <div class="name">{{ sort[sortValue].name }}</div>
                </div>
            </div>
            <FilterMenu v-if="isShowFilter" :data="detail.children" v-model="checkedActiveIndex" @change="changeChecked"/>
            <div class="sort" v-if="isShowSort">
                <div class="item" v-for="(item, index) in sort" :key="index" @click="sortValue = index">{{ item.name }}</div>
            </div>
        </div>
        <div class="layout_main wrapper">
            <div class="layout_content">
                <div class="breadcrumb only_pc"><router-link to="/shop">A<sup>+</sup>Studio Shop</router-link> / {{ detail.name }}</div>
                <div class="top flex justify_between align_end">
                    <div class="text">
                        <p class="title">{{ detail.name }}</p>
                        <p class="desc">{{ detail.desc }}</p>
                        <FilterTags :data="detail.children" v-model="checkedActiveIndex" @change="changeChecked"/>
                    </div>
                    <div class="only_pc">
                        <Picker :data="sort" v-model="sortValue"/>
                    </div>
                </div>
                <p class="all_length only_pc">{{ detail.count }} 个商品</p>
                <div class="wrapper flex">
                    <div class="only_pc">
                        <FilterMenu :data="detail.children" v-model="checkedActiveIndex" @change="changeChecked"/>
                    </div>
                    <div class="content">
                        <div class="filter_list flex flex_wrap">
                            <router-link class="item" v-for="(item, index) in list" :key="index" :to="`/shop/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <p class="name">{{ item.name }}</p>
                                <p class="price">RMB {{ item.price }}</p>
                            </router-link>
                        </div>
                        <Loading v-if="isLoading"/>
                        <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                        <div class="flex justify_center" v-else>
                            <div class="layout_btn_more" @click="getMore">查看更多</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 8.5rem;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.filter_tabs{
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    height: .7rem;
    .item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #999;
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
        &:last-child{
            border-right: none;
        }
        .name{
            text-align: center;
        }
        &::after{
            content: "";
            display: block;
            width: .14rem;
            height: .14rem;
            border-right: 1px solid #999;
            border-bottom: 1px solid #999;
            transform: translate(0, -25%) rotate(45deg);
            margin-left: .2rem;
        }
    }
}
.sort{
    padding: .3rem .6rem;
    border-bottom: 1px solid #999;
    .item{
        line-height: .6rem;
        font-size: .32rem;
    }
}
.all_length{
    font-size: .14rem;
    margin-bottom: .1rem;
}
.wrapper{
    gap: .5rem;
}
.content{
    flex: 1;
}
.filter_list{
    border-top: 1px solid #666;
    padding-top: .1rem;
    gap: .4rem .39rem;
    @media only screen and (max-width: 750px) {
        border-top: none;
    }
    .item{
        width: 2.54rem;
        text-align: center;
        font-size: .18rem;
        .cover{
            height: 0;
            padding-bottom: 100%;
            margin-bottom: .2rem;
        }
        .name{
            margin-bottom: .1rem;
        }
    }
    @media only screen and (max-width: 750px) {
        gap: .3rem;
        .item{
            width: 3.3rem;
        }
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        border-top: none;
    }
    @media only screen and (max-width: 750px) {
        padding: .4rem 0;
    }
    .top{
        margin-bottom: .4rem;
        &.center{
            text-align: center;
        }
        .title{
            font-size: .25rem;
            margin-bottom: .1rem;
            font-weight: bold;
        }
        .desc{
            font-size: .2rem;
            margin-bottom: .2rem;
        }
        @media only screen and (max-width: 750px) {
            display: block;
            .title{
                font-size: .36rem;
            }
            .desc{
                font-size: .25rem;
            }
        }
    }
}
</style>